import { ContentId } from 'src/utils/constants/contentId';
import {
  EmptyCommissionQuery,
  EmptyListingQuery,
  EmptyListingQueryV2,
  EmptyOnSaleEventQuery,
  EmptyPurchaseQuery,
  EmptyPurchaseQueryV2,
  EmptyReportV2CostOfGoodsSoldQuery,
  EmptyReportV2ListingQuery,
  EmptyReportV2PurchaseQuery,
  EmptyReportV2SaleLineItemQuery,
  EmptyReportV2SaleQuery,
  EmptyReportV2SoldTicketQuery,
  EmptyReportV2TicketGroupQuery,
  EmptySaleQuery,
  EmptySaleQueryV2,
} from 'src/utils/eventQueryUtils';
import { ReportFilterEditability } from 'src/utils/reportsFilterUtils';
import {
  FilterOperationType,
  MarketplacePaymentLineQuery,
  MarketplacePaymentQuery,
  Permission,
} from 'src/WebApiController';

import { ActivityLogFilterQuery } from '../ActivityLog/ActivityLogFilter';
import { EventSearchFilterQuery } from '../Events/EventSearch';

export type FilterToolbarItemId =
  | keyof typeof EmptyOnSaleEventQuery
  | keyof typeof EmptyListingQuery
  | keyof typeof EmptyListingQueryV2
  | keyof typeof EmptySaleQuery
  | keyof typeof EmptySaleQueryV2
  | keyof typeof EmptyPurchaseQuery
  | keyof typeof EmptyPurchaseQueryV2
  | keyof typeof EmptyCommissionQuery
  | keyof typeof EmptyReportV2SaleQuery
  | keyof typeof EmptyReportV2PurchaseQuery
  | keyof typeof EmptyReportV2ListingQuery
  | keyof typeof EmptyReportV2SoldTicketQuery
  | keyof typeof EmptyReportV2SaleLineItemQuery
  | keyof typeof EmptyReportV2CostOfGoodsSoldQuery
  | keyof typeof EmptyReportV2TicketGroupQuery
  | keyof typeof EmptyCommissionQuery
  | keyof ActivityLogFilterQuery
  | keyof EventSearchFilterQuery
  | keyof MarketplacePaymentQuery
  | keyof MarketplacePaymentLineQuery;

export const DefaultYesNoFilterToolbarItemId: FilterToolbarItemId[] = [
  'isListed',
  'isDuplicate',
  'hasListingGroupId',
  'eventHasUnsoldTickets',
  'isPredelivered',
  'isNoFulfill',
  'hasUnsoldTickets',
  'isSeatSaver',
  'isMapped',
  'isSeatingUnmapped',
  'isAutoPricingEnabled',
  'isAdminHold',
  'isPricedAboveZero',
  'isPricedByMarketplace',
  'hasBroadcastError',
  'isPendingProof',
  'isParking',
  'isConsignment',
  'isCommissionEligible',
  'isActive',
  'hasPaymentLineUnmappedToSale',
  'hasUnlinkedChargesCredits',
];

export type FilterToolbarItem = {
  filterId: FilterToolbarItemId;
  labelContentId: ContentId;
  filterItem: JSX.Element;
  postfixIcon?: JSX.Element;
  requiredPermissions?: Permission[];
  reportFilterEditability?: ReportFilterEditability;

  /**
   * Some filters, use more than one key in the query, and not all at the
   * same time, so in other to know if the filter is present or not in the
   * filters modal, we check if any of this is used.
   */
  filterQueryKeys: FilterToolbarItemId[]; // Query keys used in the filter
};

export type FilterToolbarGroup = {
  titleContentId?: ContentId;
  items: FilterToolbarItem[];
  type?: string;
  requiredPermissions?: Permission[];
};

export interface FilterDropdownItem {
  titleContentId: ContentId | undefined;
  filterId: FilterToolbarItemId;
}

export type SelectedFilters = Record<string, FilterDropdownItem[]>;

export const isUnaryRangeFilterOp = (operation: string | null | undefined) => {
  if (!operation) {
    return false;
  }

  return (
    operation === FilterOperationType.GreaterThan ||
    operation === FilterOperationType.GreaterThanOrEqual ||
    operation === FilterOperationType.LessThan ||
    operation === FilterOperationType.LessThanOrEqual
  );
};

export const useMinFilterValue = (
  operation: FilterOperationType | null | undefined
) => {
  return (
    operation === FilterOperationType.GreaterThan ||
    operation === FilterOperationType.GreaterThanOrEqual
  );
};

export const isAntiFilterOp = (
  operation: FilterOperationType | null | undefined
) => {
  if (!operation) {
    return false;
  }

  return (
    operation === FilterOperationType.NotEquals ||
    operation === FilterOperationType.NotContains ||
    operation === FilterOperationType.NotIn
  );
};
